
import React, { useState } from 'react';
import ProgressBar from './ProgressBar';
import Compress from "react-image-file-resizer";
import useSound from 'use-sound';
import success from './../../sounds/success.mp3';
import './UploadForm.css';

const UploadForm = ({ isSound }) => {
    const [file, setFile] = useState(null);
    const [error, setError] = useState(null);
    const types = ['image/png', 'image/jpeg', 'image/jpg']
    const [successSound] = useSound(success, { volume: 0.4 });

    const onFileResize = (e) => {
        const file = e.target.files[0];
        if (file && types.includes(file.type)) {
            Compress.imageFileResizer(
                file, // the file from input
                480, // width
                480, // height
                "JPEG", // compress format WEBP, JPEG, PNG
                70, // quality
                0, // rotation
                (uri) => {
                    console.log(uri);
                    isSound && successSound();
                    setFile(uri);
                },
                "file"
            );
            setError('');
        } else {
            setFile(null);
            setError('Select Image File');
        }
    }

    return (
        <form className="upload-form">
            <label className="file-upload-button file-upload">
                {!error && !file && <div> Upload Garbage</div>}
                {error && <div className="error">{error}</div>}
                {file && <div>{file.name}</div>}
                <input type="file" id="file" hidden
                    accept="image/*"
                    onChange={onFileResize} />
            </label>
            <div className="output file-upload">
                {file && <ProgressBar file={file} setFile={setFile} />}
            </div>
        </form>
    )

}

export default UploadForm;